export default "__VITE_ASSET__CmNTOhvW__"